import React, { useState } from 'react'
import { BackButton, CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { NuDate, NuInput } from '../../../../Components/Utils/Input';
import useAddFormData from '../../../../Components/Hooks/useAddFormData';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as yup from 'yup';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import { SettingHeading } from '../../../../Components/Utils/Settingheading';


function CreateSupportTickets() {
  const navigate = useNavigate();
  const {  addFormData } = useAddFormData();
 
     const [createNew, setCreateNew] = useState({
    Client:"",
    Subject:"",
    TicketDate:"",
    ResponseDate:"",
    Status:"",
    Priority:"",
    Division:""
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
          }),
    onSubmit: async (value, { resetForm }) => {
           addFormData("/employees/ ", value, resetForm);
    },
  });
 
 

  return (
    <div className=" w-full h-full py-2 px-4 ">
         <div className="flex justify-between w-full">  
         <Breadcrumb
                  items={[
                    // { name: "Testing&Commissioning" },
                    {   name: "Support-Tickets" ,
                      link:"/tickets/support-tickets"
                    },
                    { name: "Create" },
                  ]}
                />      
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-xl overflow-hidden mt-4">
          <div className=" w-full h-full flex justify-start content-start flex-wrap py-2 px-4  overflow-y-auto">
            <div className="w-full">
                         <SettingHeading title="Support Ticket "  />

            </div>
            {/* <FormikSelectTwo
              label="Type"
              Options={[
                { value: "Contractual", label: "Contractual" },
      { value: "Non-Contractual", label: "Non-Contractual" },
              ]}
              formik={formik}
              placeholder="Choose"
              name="Type"
              isRequired={true}

              width="w-full md:w-1/3 md:-mt-2"
            /> */}

            <FormikSelectTwo
              label="Client"
              Options={[
                { value: "Client A", label: "Client A" },
      { value: "Client B", label: "Client B" },
              ]}
              formik={formik}
              placeholder="Choose"
              name="Client"
              isRequired={true}

              width="w-full md:w-1/3 md:-mt-2"
            />

             <NuInput
             type="text"
              label="Subject"
      //         Options={[
      //           { value: "project1", label: "Project X" },
      // { value: "project2", label: "Project Y" },
      //         ]}
              formik={formik}
              placeholder="Choose"
              name="Subject"
              isRequired={true}

              width="w-full md:w-1/3 md:-mt-2"
            />
            <FormikSelectTwo
               label="Priority"
               Options={[
                 { value: "High", label: "High" },
                  { value: "Medium", label: "Medium" },
               ]}
               formik={formik}
               placeholder="Choose"
               name="Priority"
               isRequired={true}
               width="w-full md:w-1/3 md:-mt-2"
             />
            <NuInput
             type="text"
              label="Priority"
      //         Options={[
      //           { value: "project1", label: "Project X" },
      // { value: "project2", label: "Project Y" },
      //         ]}
              formik={formik}
              placeholder="Choose"
              name="Priority"
              isRequired={true}

              width="w-full md:w-1/3 md:-mt-2"
            />
            <FormikSelectTwo
              label="Division"
              Options={[
                { value: "Division 1", label: "Division 1" },
      { value: "Division 2", label: "Division 2" },
              ]}
              formik={formik}
              placeholder="Choose"
              name="Division"
              isRequired={true}

              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuDate
              label="Ticket Date"
              placeholder="Ticket Date"
              formik={formik}
              name="TicketDate"
             
              width="w-full md:w-1/3 md:-mt-2"
            />

<NuDate
              label="Response Date"
              placeholder="Response Date"
              formik={formik}
              name="ResponseDate"
             
              width="w-full md:w-1/3 md:-mt-2"
            />

{/* <FormikSelectTwo
              label="Status"
              Options={[
                { value: "Pending", label: "Pending" },
      { value: "Completed", label: "Completed" },
              ]}
              formik={formik}
              placeholder="Choose"
              name="Status"
              isRequired={true}

              width="w-full md:w-1/3 md:-mt-2"
            /> */}
           
           
           <div className="w-full  my-4 mt-8 ">
              <div className=" flex justify-end gap-4">
                 <CancelButton
                  handleClick={() => {
                    navigate(-1);
                  }}
                />
                <SubmitButton />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default CreateSupportTickets
